export const parseDate = dashedDate => dashedDate.replace(/-/g, '. ');
